import React, { useCallback } from "react";
import { Input } from "antd";
import { useTranslation } from "react-i18next";

export default function Search({
  setSearchString,
}: {
  setSearchString: (searchString: string) => void;
}) {
  const { t } = useTranslation();

  const searchStringHeader = useCallback(
    (value) => {
      setSearchString(value);
    },
    [setSearchString],
  );

  return (
    <div>
      <Input.Search
        allowClear
        onSearch={searchStringHeader}
        size="large"
        placeholder={t("translation:search")}
      />
    </div>
  );
}
